var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import '../team-form/team-form.js';
import '../../atoms/icon-button/icon-button.js';
import '../../atoms/tag/tag.js';
import '../team-participant-list/team-participant-list.js';
import { html } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styleMap } from 'lit/directives/style-map.js';
import { SgdfElement } from '../../internal/sgdf-element.js';
import styles from './team-item.styles.js';
let SgdfTeamItem = class SgdfTeamItem extends SgdfElement {
    constructor() {
        super(...arguments);
        this.forceDetail = false;
        this.isEdit = false;
        this.showDetail = false;
    }
    handleShowDetail() {
        this.showDetail = !this.showDetail;
    }
    onAction() {
        this.isEdit = !this.isEdit;
    }
    getHeader(participants) {
        return html `
            <div class="header">
                ${this.isEdit
            ? html `<div
                              class="team-form"
                              style=${styleMap({ borderColor: this.team.color })}
                          >
                              <sgdf-team-form
                                  .team=${this.team}
                                  .participants=${this.participants}
                                  @sgdf-team:update=${this.onAction}
                                  @sgdf-team:delete=${this.onAction}
                              ></sgdf-team-form>
                          </div>`
            : html `<div
                              class="team-peview ${classMap({
                open: this.forceDetail || this.showDetail,
            })}"
                              style=${styleMap({
                backgroundColor: this.team.color,
            })}
                          >
                              <div class="left">
                                  <span class="label">${this.team.label}</span>
                                  <sgdf-icon-button
                                      @click=${this.onAction}
                                      name="pen"
                                      style="--icon-color: white;"
                                  ></sgdf-icon-button>
                              </div>
                              <div class="right">
                                  <sgdf-tag
                                      style="--border-color: white;"
                                      pill
                                      size="small"
                                      >${participants.length}</sgdf-tag
                                  >
                                  ${participants.length
                ? html `${!this.forceDetail
                    ? this.showDetail
                        ? html `<sgdf-icon-button
                                                              @click=${this
                            .handleShowDetail}
                                                              style="--icon-color: white;"
                                                              name="chevron-down"
                                                          ></sgdf-icon-button>`
                        : html `<sgdf-icon-button
                                                              @click=${this
                            .handleShowDetail}
                                                              style="--icon-color: white;"
                                                              name="chevron-right"
                                                          ></sgdf-icon-button>`
                    : null}`
                : null}
                              </div>
                          </div>`}
            </div>
        `;
    }
    getDetail(participants) {
        return html `
            <div
                class="participant-list-container"
                style=${styleMap({ '--team-color': this.team.color })}
            >
                <sgdf-team-participant-list
                    .participants=${participants}
                    .teamId=${this.team.id}
                ></sgdf-team-participant-list>
            </div>
        `;
    }
    render() {
        const participants = this.participants.filter(p => p.teams.findIndex(team => team.id === this.team.id) >= 0);
        return html `<div class="team-item">
            ${this.getHeader(participants)}
            ${this.forceDetail || this.showDetail
            ? this.getDetail(participants)
            : null}
        </div>`;
    }
};
SgdfTeamItem.styles = styles;
__decorate([
    property({ type: Object, reflect: true })
], SgdfTeamItem.prototype, "team", void 0);
__decorate([
    property({ type: Array, reflect: true })
], SgdfTeamItem.prototype, "participants", void 0);
__decorate([
    property({ type: Boolean, reflect: true })
], SgdfTeamItem.prototype, "forceDetail", void 0);
__decorate([
    state()
], SgdfTeamItem.prototype, "isEdit", void 0);
__decorate([
    state()
], SgdfTeamItem.prototype, "showDetail", void 0);
SgdfTeamItem = __decorate([
    customElement('sgdf-team-item')
], SgdfTeamItem);
export default SgdfTeamItem;
//# sourceMappingURL=team-item.js.map